$(document).ready(function () {
  // Handle the "Add to Cart" button click
  $('.add-to-cartw').on('click', function (event) {
    // Check if any checkboxes are selected
    var anySelected = $('.product-checkbox:checked').length > 0;

    if (anySelected) {
      // If checkboxes are selected, prevent the default action of the "Add to Cart" button
      event.preventDefault();

      // Add selected products and the current product to the cart
      addSelectedProductsAndCurrentProductToCart();
    }
    // If no checkboxes are selected, let the default "Add to Cart" behavior proceed
  });
  function addSelectedProductsAndCurrentProductToCart() {
    var selectedProducts = [];

    // Iterate through selected checkboxes
    $('.product-checkbox:checked').each(function () {
      var productId = $(this).data('product-id');
      var variantId = $(this).data('variant-id');
      var quantity = 1; // You may adjust the quantity based on your requirements

      // Add product details to the array
      selectedProducts.push({
        id: variantId,
        quantity: quantity,
      });
    });

    // Add details of the current product on the product page
    var currentProduct = {
      // id: $('[data-variants-id]').data('variants-id'),
     id: $('.new').val(),
      quantity: 1, // You may adjust the quantity based on your requirements
    };

    // Combine selected products and the current product
    var allProducts = selectedProducts.concat([currentProduct]);

    // Prepare data for AJAX request
    var data = {
      items: allProducts,
    };

    // Perform AJAX request to add products to the cart
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function () {
        // Handle success (e.g., redirect to the cart page)
        window.location.href = '/cart';
      },
      error: function (response) {
        // Handle errors (e.g., show an alert)
        console.error(response);
      },
    });
  }
});
